import { setLoading } from '../../features/common/loadingSlice';

const loadingMiddleware = store => next => action => {
  const { type } = action;
  if (type.endsWith('/pending') && !type.includes('noLoading')) {
    store.dispatch(setLoading(true));
  } else if (
    (type.endsWith('/fulfilled') || type.endsWith('/rejected')) &&
    !type.includes('noLoading')
  ) {
    store.dispatch(setLoading(false));
  }
  return next(action);
};

export default loadingMiddleware;
